import NewsCard from './news-card';

export default class NewsCardDesktop extends NewsCard {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/news-card/news-card.desktop.js